"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTapeBuilderFromArtifactsDocument = exports.createTapeBuilder = void 0;
const common_1 = require("@finley-technologies/common");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const consts_1 = require("./consts");
const convertor_1 = require("./convertor");
const typeguards = __importStar(require("./typeguards"));
/**
 * create tape builder. Tape Builder provides interface to generate tapes and their definitions
 * given TapeBuilderTask and dependent tapes
 * @param {DbTable.ArtifactWithSlugs} artifacts - array of artifacts from the document.
 *  All the tape dependencies must be present in this map (except for raw tapes)
 * @returns {ITapeBuilder} tape builder interface
 */
const createTapeBuilder = (artifacts) => {
    // returns the artifact record for the given tape id
    const getTask = (id) => {
        const artifact = artifacts.find((record) => record.id === id);
        (0, common_1.finleyAssert)(artifact, `could not find tape with [artifactId:${id}]`);
        (0, common_1.finleyAssert)(typeguards.isTapeBuilderTask(artifact.configuration), `tape configuration is not of task TapeBuilderTask: ${JSON.stringify(artifact.configuration)}`);
        return artifact.configuration;
    };
    const getIdFromSlug = (slug) => {
        const artifact = artifacts.find(({ artifactSlug }) => slug === artifactSlug);
        (0, common_1.finleyAssert)(artifact, `could not find artifact with [artifactSlug:${slug}]`);
        return artifact.id;
    };
    // `Transformation` is configuration for how tapes are 'sanitized' or 'edited' or 'joined'
    // these configuration include (a) input tape definitions and (b) operation specific parameters.
    // Tape builder has (b) in its TapeBuilderTask's. It generates (a) by walking back the dependency tree here.
    const convertTransformationOperation = ({ task, fieldDefinitionCallback, }) => {
        switch (task.operation) {
            case 'attachHeader': {
                const { srcArtifactSlug: _unused, ...restOfAttachHeaderParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfAttachHeaderParams,
                    },
                };
            }
            case 'unzip': {
                const { srcArtifactSlug: _unused, ...restOfAttachHeaderParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfAttachHeaderParams,
                    },
                };
            }
            case 'xlsx2csv': {
                const { srcArtifactSlug: _unused, ...restOfXlsx2CsvParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfXlsx2CsvParams,
                    },
                };
            }
            case 'xlsx2csv2': {
                const { srcArtifactSlug: _unused, ...restOfParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfParams,
                    },
                };
            }
            case 'pyXlsx2Csv2': {
                const { srcArtifactSlug: _unused, ...restOfParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfParams,
                    },
                };
            }
            case 'pdf2csv': {
                const { srcArtifactSlug: _unused, ...restOfPdf2CsvParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfPdf2CsvParams,
                    },
                };
            }
            case 'preFilter': {
                const { srcArtifactSlug: _unused, ...restOfParams } = task;
                return {
                    isValid: true,
                    data: {
                        srcDataTape: null,
                        ...restOfParams,
                    },
                };
            }
            case 'sanitize': {
                const { baseFields, delimiter, doNotSanitizeFieldNames } = task;
                const sanitizeFieldNames = !doNotSanitizeFieldNames;
                return {
                    isValid: true,
                    data: {
                        operation: 'sanitize',
                        srcDataTape: {
                            baseFields,
                            delimiter,
                        },
                        sanitizeFieldNames,
                    },
                };
            }
            case 'filter': {
                const { operation, srcArtifactSlug, filterFormula } = task;
                const srcDataTape = fieldDefinitionCallback(srcArtifactSlug);
                if (!srcDataTape.isValid) {
                    return {
                        isValid: false,
                        errors: srcDataTape.errors,
                    };
                }
                (0, common_1.finleyAssert)(srcDataTape.data, 'TapeDefinition is null for filter operation inputs');
                return {
                    isValid: true,
                    data: {
                        operation,
                        srcDataTape: srcDataTape.data,
                        filterFormula,
                    },
                };
            }
            case 'join': {
                const { srcArtifactSlug, joinArtifactSlug, ...restOfJoinParams } = task;
                const srcDataTape = fieldDefinitionCallback(srcArtifactSlug);
                const joinDataTape = fieldDefinitionCallback(joinArtifactSlug);
                if (srcDataTape.isValid && joinDataTape.isValid) {
                    (0, common_1.finleyAssert)(srcDataTape.data && joinDataTape.data, 'TapeDefinition is null for join operation inputs ');
                    return {
                        isValid: true,
                        data: {
                            srcDataTape: srcDataTape.data,
                            joinDataTape: joinDataTape.data,
                            ...restOfJoinParams,
                        },
                    };
                }
                const errors = [];
                if (!srcDataTape.isValid) {
                    errors.push(...srcDataTape.errors);
                }
                if (!joinDataTape.isValid) {
                    errors.push(...joinDataTape.errors);
                }
                return {
                    isValid: false,
                    errors,
                };
            }
            case 'edit': {
                const { srcArtifactSlug, fieldModifications } = task;
                const srcDataTape = fieldDefinitionCallback(srcArtifactSlug);
                if (srcDataTape.isValid) {
                    (0, common_1.finleyAssert)(srcDataTape.data, 'TapeDefinition is null for edit operation inputs ');
                    return {
                        isValid: true,
                        data: {
                            operation: 'edit',
                            srcDataTape: srcDataTape.data,
                            fieldModifications,
                        },
                    };
                }
                return {
                    isValid: false,
                    errors: srcDataTape.errors,
                };
            }
            case 'flatten': {
                const { srcArtifactSlug, groupByField, aggregationFields } = task;
                const srcDataTape = fieldDefinitionCallback(srcArtifactSlug);
                if (srcDataTape.isValid) {
                    (0, common_1.finleyAssert)(srcDataTape.data, 'TapeDefinition is null for flatten operation inputs ');
                    return {
                        isValid: true,
                        data: {
                            operation: 'flatten',
                            srcDataTape: srcDataTape.data,
                            groupByField,
                            aggregationFields,
                        },
                    };
                }
                return {
                    isValid: false,
                    errors: srcDataTape.errors,
                };
            }
            case 'stack': {
                const { srcArtifactSlug, otherArtifactSlugs, ensureUniqueFields, } = task;
                const inputSlugs = [srcArtifactSlug, ...otherArtifactSlugs];
                const inputTapeDefinitionResults = inputSlugs.map((slug) => fieldDefinitionCallback(slug));
                const errors = [];
                const inputTapeDefinitions = inputTapeDefinitionResults.map((tape) => {
                    if (!tape.isValid) {
                        errors.push(...tape.errors);
                        return null;
                    }
                    if (!tape.data) {
                        errors.push('Stack operation requires sanitized tapes as inputs. Are you using the correct tapes?');
                        return null;
                    }
                    return tape.data;
                });
                if (errors.length) {
                    return {
                        isValid: false,
                        errors,
                    };
                }
                const validTapeDefinitions = inputTapeDefinitions.filter(common_1.typeguards.isNotNullOrUndefined);
                return {
                    isValid: true,
                    data: {
                        operation: 'stack',
                        srcDataTape: validTapeDefinitions[0],
                        otherDataTapes: validTapeDefinitions.slice(1),
                        ensureUniqueFields,
                    },
                };
            }
            default:
                (0, common_1.finleyAssertUnreachable)(task);
        }
        (0, common_1.finleyAssert)(false, 'should not reach here');
    };
    // generates tape definition (base fields) for the given artifact
    const generateTapeDefinition = (artifactId) => {
        const task = getTask(artifactId);
        // generateTapeDefinition and convertTransformationOperation
        // are mutually recursive functions, hence the callback
        const transformation = convertTransformationOperation({
            task,
            fieldDefinitionCallback: (tapeSlug) => generateTapeDefinition(getIdFromSlug(tapeSlug)),
        });
        if (!transformation.isValid) {
            return {
                isValid: false,
                errors: transformation.errors,
            };
        }
        if (!transformation.data) {
            // for tapes which has no definition associated.
            // e.g. xlsx2csv,
            return {
                isValid: true,
                data: null,
            };
        }
        const output = (0, tape_sanitizer_1.transformDataTapeDefinition)(transformation.data);
        if (output.isValid) {
            return {
                isValid: true,
                data: output.data,
            };
        }
        const errors = output.errors.map((error) => error.message);
        return {
            isValid: false,
            errors,
        };
    };
    const getTransformation = (artifactId) => {
        const task = getTask(artifactId);
        // convert configuration to tape-sanitizer transformation
        const transformation = convertTransformationOperation({
            task,
            fieldDefinitionCallback: (tapeSlug) => generateTapeDefinition(getIdFromSlug(tapeSlug)),
        });
        // we do not expect errors in transformation at the time
        // of generating tape, as these errors will be surfaced before
        // saving tape generation pipeline
        (0, common_1.finleyAssert)(transformation.isValid, `transformation is invalid: ${JSON.stringify(transformation)}`);
        return {
            transformation: transformation.data,
            srcArtifactSlug: task.srcArtifactSlug,
        };
    };
    const generateTape = async ({ artifactId, inputTapeBuffers, pdfExtractor, pyXslx2CsvExtractor, }) => {
        const task = getTask(artifactId);
        const getBuffer = async (slug) => {
            const inputArtifactId = getIdFromSlug(slug);
            const buffer = inputTapeBuffers.get(inputArtifactId);
            // if the input buffer does not exist see if it can be created.
            // as long as leaf nodes needed for the target node are
            // provided we should be able to generate requested artifactId.
            if (!buffer) {
                const previousResult = await generateTape({
                    artifactId: inputArtifactId,
                    inputTapeBuffers,
                    pdfExtractor,
                });
                if (previousResult.isValid) {
                    return previousResult.data.outputBuffer;
                }
            }
            (0, common_1.finleyAssert)(buffer, `could not find/generate buffer for [artifactSlug:${slug}]`);
            return buffer;
        };
        // this function returns operation specific slugs
        // for which we need to get buffers
        // (besides srcArtifactSlug)
        // TODO: move this operation specific folder uinodes/operations/xxx/converter.ts
        const getOtherSlugs = () => {
            switch (task.operation) {
                case 'stack':
                    return task.otherArtifactSlugs;
                case 'join':
                    return [task.joinArtifactSlug];
                default:
                    return [];
            }
        };
        const { srcArtifactSlug } = task;
        const srcDataTapeBuffer = await getBuffer(srcArtifactSlug);
        const otherSlugs = getOtherSlugs();
        const otherDataTapeBuffers = await Promise.all(otherSlugs.map(getBuffer));
        const output = await (0, tape_sanitizer_1.transformDataTape)({
            transformation: getTransformation(artifactId).transformation,
            srcDataTapeBuffer,
            otherDataTapeBuffers,
            pdfExtractor,
            pyXslx2CsvExtractor,
        });
        return output;
    };
    const getGeneratedLoanTapeConfig = (artifactId) => {
        // we assume that the artifact is a generatedLoanTape
        const artifact = artifacts.find(({ id }) => id === artifactId);
        (0, common_1.finleyAssert)(typeguards.isTapeBuilderRecordUI(artifact), 'not a tapeBuilder record');
        (0, common_1.finleyAssert)((0, consts_1.isTapeBuilderRecordGeneratedLoanTape)(artifact), 'not a loan tape');
        return artifact.configuration;
    };
    const generateTapeDefinitionBySlug = (artifactSlug) => {
        return generateTapeDefinition(getIdFromSlug(artifactSlug));
    };
    const generateTapeBySlug = async ({ artifactSlug, inputTapeBuffers, }) => {
        const inputTapeBuffersById = new Map();
        inputTapeBuffers.forEach((buffer, slug) => {
            inputTapeBuffersById.set(getIdFromSlug(slug), buffer);
        });
        return generateTape({
            artifactId: getIdFromSlug(artifactSlug),
            inputTapeBuffers: inputTapeBuffersById,
        });
    };
    return {
        generateTapeDefinition,
        generateTapeDefinitionBySlug,
        generateTape,
        generateTapeBySlug,
        getGeneratedLoanTapeConfig,
        getTransformation,
    };
};
exports.createTapeBuilder = createTapeBuilder;
const createTapeBuilderFromArtifactsDocument = (artifactsDocument) => {
    const { dataTapes } = convertor_1.convertor.dbRecordsFromArtifactsDocument({
        artifactsDocument,
    });
    return (0, exports.createTapeBuilder)(dataTapes);
};
exports.createTapeBuilderFromArtifactsDocument = createTapeBuilderFromArtifactsDocument;
//# sourceMappingURL=tapeBuilder.js.map